/**
 * TO run a new mirage scenario from command line:
 *
 * 1. Create a new scenario file in either 'mirage/scenarios' or  'mirage/scenarios/personal'
 * 2. Run the following command to fire up the mirage dev server using your scenario.
 *
 * `MIRAGE_SCENARIO=<scenario of your choice> yarn start:mirage`
 */

import ENV from '../../config/environment';

/**
 * Initializes mirage server with the active mirage scenario
 *
 * @param {object} server Mirage Server
 */
export default function (server) {
  /* eslint-disable no-console */
  const { MIRAGE_SCENARIO } = ENV;

  let scenario;

  if (MIRAGE_SCENARIO) {
    try {
      scenario = loadScenario(`personal/${MIRAGE_SCENARIO}`);
    } catch {
      scenario = loadScenario(MIRAGE_SCENARIO);
    }
  } else {
    scenario = loadScenario('main');
  }

  if (scenario) {
    scenario(server);
  }
}

/**
 * @param {string} scenario senario name
 * @returns {object} scenario initializer function
 */
function loadScenario(scenarioName) {
  /* global require */
  // use require() instead of dynamic import() because ember-auto-import can't handle
  // a dynamically-constructed path name (it just drops the interpolated part). It also
  // doesn't support a relative path (that is only available with Embroider).
  let scenario;
  try {
    scenario = require(`garaje/mirage/scenarios/${scenarioName}`).default;
    console.log('Using Mirage scenario "%s"', scenarioName);
  } catch (e) {
    console.warn('Could not load Mirage scenario "%s"', scenarioName);
    throw e;
  }

  return scenario;
}
